var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1766_9536",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1766_9536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7667 4.66667C13.7667 3.8 13.4667 3.06667 12.8667 2.46667C12.2667 1.86667 11.5333 1.56667 10.6667 1.56667V0.666672C11.7778 0.666672 12.7222 1.05556 13.5 1.83334C14.2778 2.61112 14.6667 3.55556 14.6667 4.66667H13.7667ZM12 4.66667C12 4.3 11.8694 3.98612 11.6083 3.725C11.3472 3.46389 11.0333 3.33334 10.6667 3.33334V2.43334C11.2778 2.43334 11.7972 2.65 12.225 3.08334C12.6528 3.51667 12.8778 4.04445 12.9 4.66667H12ZM2.66666 14C2.29999 14 1.98611 13.8694 1.72499 13.6083C1.46388 13.3472 1.33333 13.0333 1.33333 12.6667V4.66667C1.33333 4.3 1.46388 3.98612 1.72499 3.725C1.98611 3.46389 2.29999 3.33334 2.66666 3.33334H4.76666L5.99999 2.00001H9.99999V3.33334H6.58333L5.36666 4.66667H2.66666V12.6667H13.3333V5.33334H14.6667V12.6667C14.6667 13.0333 14.5361 13.3472 14.275 13.6083C14.0139 13.8694 13.7 14 13.3333 14H2.66666ZM7.99999 11.6667C8.83333 11.6667 9.54166 11.375 10.125 10.7917C10.7083 10.2083 11 9.5 11 8.66667C11 7.83334 10.7083 7.125 10.125 6.54167C9.54166 5.95834 8.83333 5.66667 7.99999 5.66667C7.16666 5.66667 6.45833 5.95834 5.87499 6.54167C5.29166 7.125 4.99999 7.83334 4.99999 8.66667C4.99999 9.5 5.29166 10.2083 5.87499 10.7917C6.45833 11.375 7.16666 11.6667 7.99999 11.6667ZM7.99999 10.3333C7.53333 10.3333 7.13888 10.1722 6.81666 9.85001C6.49444 9.52778 6.33333 9.13334 6.33333 8.66667C6.33333 8.2 6.49444 7.80556 6.81666 7.48334C7.13888 7.16112 7.53333 7 7.99999 7C8.46666 7 8.86111 7.16112 9.18333 7.48334C9.50555 7.80556 9.66666 8.2 9.66666 8.66667C9.66666 9.13334 9.50555 9.52778 9.18333 9.85001C8.86111 10.1722 8.46666 10.3333 7.99999 10.3333Z",
    fill: "#722ED1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.eeaf9d8a7400776a5caca01c0d4ae3bd.svg";
export { ForwardRef as ReactComponent };